import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "bg-white rounded-2xl shadow-xl max-w-lg w-full max-h-[90vh] overflow-y-auto" };
const _hoisted_2 = { class: "p-6 border-b border-gray-200" };
const _hoisted_3 = { class: "text-xl font-bold text-gray-900" };
const _hoisted_4 = { class: "text-sm text-gray-600 mt-1" };
const _hoisted_5 = { class: "mt-3 h-2 bg-gray-100 rounded-full overflow-hidden" };
const _hoisted_6 = {
    key: 0,
    class: "p-6 text-red-600 text-sm"
};
const _hoisted_7 = {
    key: 1,
    class: "p-4 text-center text-gray-600 text-sm"
};
const _hoisted_8 = { class: "p-4 flex justify-between gap-2 border-t" };
const _hoisted_9 = ["disabled"];
import { ref, computed, watch } from 'vue';
import ProductConfigModal from '../ProductConfigModal.vue';
import { needsProductConfiguration } from '@shared/utils/productConfiguration';
export default /*@__PURE__*/ _defineComponent({
    __name: 'MenuConfigWizard',
    props: {
        isOpen: { type: Boolean },
        menu: {},
        products: {}
    },
    emits: ["close", "complete"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const currentStep = ref(0);
        const componentConfigs = ref([]);
        const configModalOpen = ref(false);
        const configProduct = ref(null);
        const componentProducts = computed(() => {
            if (!props.menu?.components?.length)
                return [];
            return props.menu.components
                .map((comp) => {
                const productRef = comp.product;
                const productId = typeof productRef === 'object'
                    ? productRef._id || productRef.id
                    : productRef;
                const product = props.products.find((p) => p.id === productId || p._id === productId);
                return product ? { product, label: comp.label } : null;
            })
                .filter(Boolean);
        });
        const currentProduct = computed(() => componentProducts.value[currentStep.value]?.product);
        const progressPercent = computed(() => {
            if (!componentProducts.value.length)
                return 0;
            return Math.round(((currentStep.value + 1) / componentProducts.value.length) * 100);
        });
        watch(() => props.isOpen, (open) => {
            if (open) {
                currentStep.value = 0;
                componentConfigs.value = [];
                configModalOpen.value = false;
                configProduct.value = null;
                if (componentProducts.value.length) {
                    setTimeout(() => openConfigForCurrent(), 0);
                }
            }
        });
        const mapConfiguredToComponent = (configured) => ({
            productId: configured._id || configured.id,
            productName: configured.name,
            selectedSize: configured.selectedSize,
            extras: configured.extras,
            removedIngredients: configured.removedIngredients,
            selectedMandatoryIngredients: configured.selectedMandatoryIngredients,
            specialInstructions: configured.specialInstructions
        });
        const finishMenu = () => {
            if (!props.menu)
                return;
            const menuPriceEuro = (props.menu.menuPriceCent || 0) / 100;
            emit('complete', {
                menu: props.menu,
                componentConfigs: [...componentConfigs.value],
                totalPrice: menuPriceEuro,
                totalPriceCent: props.menu.menuPriceCent,
                totalDepositCent: 0
            });
        };
        const advanceOrFinish = () => {
            if (currentStep.value >= componentProducts.value.length - 1) {
                finishMenu();
                return;
            }
            currentStep.value += 1;
            openConfigForCurrent();
        };
        const onComponentConfigured = (configured) => {
            configModalOpen.value = false;
            componentConfigs.value.push(mapConfiguredToComponent(configured));
            advanceOrFinish();
        };
        const openConfigForCurrent = () => {
            const product = currentProduct.value;
            if (!product)
                return;
            if (!needsProductConfiguration(product)) {
                componentConfigs.value.push({
                    productId: product._id || product.id,
                    productName: product.name
                });
                advanceOrFinish();
                return;
            }
            configProduct.value = product;
            configModalOpen.value = true;
        };
        return (_ctx, _cache) => {
            return (_ctx.isOpen && _ctx.menu)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "fixed inset-0 z-[60] flex items-center justify-center bg-black/50 p-4",
                    onClick: _cache[2] || (_cache[2] = _withModifiers(($event) => (_ctx.$emit('close')), ["self"]))
                }, [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.menu.name), 1 /* TEXT */),
                            _createElementVNode("p", _hoisted_4, " Schritt " + _toDisplayString(currentStep.value + 1) + " von " + _toDisplayString(componentProducts.value.length) + ": " + _toDisplayString(currentProduct.value?.name || 'Komponente'), 1 /* TEXT */),
                            _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("div", {
                                    class: "h-full bg-red-600 transition-all",
                                    style: _normalizeStyle({ width: `${progressPercent.value}%` })
                                }, null, 4 /* STYLE */)
                            ])
                        ]),
                        (!currentProduct.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, " Produkt für diese Menü-Komponente wurde nicht gefunden. "))
                            : (_openBlock(), _createElementBlock("div", _hoisted_7, " Konfigurieren Sie „" + _toDisplayString(currentProduct.value.name) + "“ im nächsten Dialog. ", 1 /* TEXT */)),
                        _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("button", {
                                type: "button",
                                class: "px-4 py-2 border rounded-lg text-gray-700",
                                onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('close')))
                            }, " Abbrechen "),
                            _createElementVNode("button", {
                                type: "button",
                                class: "px-4 py-2 bg-red-600 text-white rounded-lg font-semibold",
                                disabled: !currentProduct.value,
                                onClick: openConfigForCurrent
                            }, _toDisplayString(currentProduct.value ? 'Jetzt konfigurieren' : 'Weiter'), 9 /* TEXT, PROPS */, _hoisted_9)
                        ])
                    ]),
                    (configProduct.value)
                        ? (_openBlock(), _createBlock(ProductConfigModal, {
                            key: 0,
                            isOpen: configModalOpen.value,
                            product: configProduct.value,
                            onClose: _cache[1] || (_cache[1] = ($event) => (configModalOpen.value = false)),
                            onAddToCart: onComponentConfigured
                        }, null, 8 /* PROPS */, ["isOpen", "product"]))
                        : _createCommentVNode("v-if", true)
                ]))
                : _createCommentVNode("v-if", true);
        };
    }
});
